import { NavLink, matchPath, resolvePath, useLocation, useResolvedPath } from 'react-router';
import styled from 'styled-components';
import { type Page } from '../TopBarUI';

export const NavLinks: React.FC<{ className?: string; pages: Page[]; isManagerView?: boolean }> = ({
  className,
  pages,
  isManagerView = false,
}) => {
  const resolvedPath = useResolvedPath('', { relative: 'route' });
  const location = useLocation();

  const pagesExt = pages.map((page) => {
    const path = resolvePath(page.path, resolvedPath.pathname);
    const m = matchPath(path.pathname, location.pathname);
    return { ...page, active: !!m };
  });

  return (
    <>
      <LinksContainer className={className}>
        {pagesExt.map(({ name, path, active }) => (
          <NLink key={path} to={path} $isManagerView={isManagerView} className={active ? 'active' : undefined}>
            {name}
          </NLink>
        ))}
        <DisabledLink aria-disabled="true">
          <span>Engage</span>
          <SoonBadge>Soon</SoonBadge>
        </DisabledLink>
      </LinksContainer>
    </>
  );
};

const NLink = styled(NavLink)<{ $isManagerView: boolean }>`
  position: relative;
  text-decoration: none;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.normal};
  font-size: 14px;
  font-weight: 500;
  height: 100%;
  margin: 0;
  padding: 10px 0px 12px;
  line-height: 18px;
  transition: color 180ms ease;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 8px;
    height: 2px;
    border-radius: 999px;
    background: transparent;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.heading};
  }

  &.active {
    color: ${({ theme }) => theme.colors.primary};
  }

  &.active::after {
    background: ${({ theme }) => theme.colors.primary};
    box-shadow: none;
  }
`;

const LinksContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  position: relative;
  min-height: 32px;

  @media (max-width: 768px) {
    display: none;
  }
`;

const DisabledLink = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: ${({ theme }) => theme.colors.normal};
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  opacity: 0.8;
  padding: 10px 0 12px;
`;

const SoonBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 18px;
  padding: 2px 8px;
  border-radius: 999px;
  background: ${({ theme }) => theme.colors.topBarSubtleBackground};
  border: 1px solid ${({ theme }) => theme.colors.topBarBorder};
  color: ${({ theme }) => theme.colors.normal};
  font-size: 10px;
  line-height: 14px;
`;
